import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

const ended = (d) => `${d.sessions} Conduit session${d.sessions === 1 ? "" : "s"}` + (d.apps ? ` and ${d.apps} connected app${d.apps === 1 ? "" : "s"}` : "");

/** After an edit: tell the admin the person was signed out because a security field changed. */
export function toastAccessReset(data, name) {
  const r = data?.access_reset;
  if (!r) return;
  toast.info(`${name || "They"} must sign in again — ${r.reasons.join(", ")} changed (${ended(r)} ended).`, { duration: 7000 });
}

/** Confirm + end every Conduit session and connected-app login of one account. Render outside menus. */
export function SignOutEverywhereDialog({ user, onClose }) {
  const [busy, setBusy] = useState(false);
  if (!user) return null;
  const go = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/users/${user.user_id}/sign-out-everywhere`);
      toast.success(`${user.name || user.email} signed out everywhere — ${ended(data)} ended${data.kept_current ? " (this browser stays signed in)" : ""}.`);
      onClose();
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Could not sign them out"); }
    finally { setBusy(false); }
  };
  return (
    <AlertDialog open onOpenChange={(o) => !o && onClose()}>
      <AlertDialogContent data-testid="sign-out-everywhere-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>Sign {user.name || user.email} out everywhere?</AlertDialogTitle>
          <AlertDialogDescription>
            Ends every Conduit login on every device and stops connected apps (like KB and TalentLMS) from refreshing their access. They can sign in again straight away with their current e-mail and password — use Deactivate to keep them out.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="sign-out-everywhere-cancel">Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={(e) => { e.preventDefault(); go(); }} disabled={busy} data-testid="sign-out-everywhere-confirm">
            {busy ? "Signing out…" : "Sign out everywhere"}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
